// removed by extract-text-webpack-plugin
module.exports = {"container":"OP9It"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-video-embed/post-video-embed.scss
// module id = 1076
// module chunks = 0 3 4 6